import { render, staticRenderFns } from "./customer_pool_dashboard.vue?vue&type=template&id=7516b8a6&scoped=true"
import script from "./customer_pool_dashboard.vue?vue&type=script&lang=js"
export * from "./customer_pool_dashboard.vue?vue&type=script&lang=js"
import style0 from "./customer_pool_dashboard.vue?vue&type=style&index=0&id=7516b8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7516b8a6",
  null
  
)

export default component.exports